/** Backend upload_context values for POST /api/v1/files */
export type FileUploadContext =
  | "property"
  | "vehicle_condition_check"
  | "permit_vehicle_proof"
  | "permit_sticker"
  | "task"
  | "vehicle_check";

export type BuildUploadFormDataOptions = {
  upload_context?: FileUploadContext | string;
  task_id?: number;
  phase_key?: string;
};

export function buildUploadFormData(
  files: File[],
  options?: FileUploadContext | BuildUploadFormDataOptions,
): FormData {
  const form = new FormData();
  const resolved: BuildUploadFormDataOptions =
    typeof options === "string" ? {upload_context: options} : (options ?? {});

  if (resolved.upload_context) {
    form.append("upload_context", resolved.upload_context);
  }

  if (resolved.task_id != null) {
    form.append("task_id", String(resolved.task_id));
  }

  if (resolved.phase_key) {
    form.append("phase_key", resolved.phase_key);
  }

  for (const file of files) {
    form.append("files[]", file);
  }

  return form;
}
